import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    formataEstudoHelpText,
} from '../../../business-components/Formata/Formata'

import {
    GridItem12,
 } from '../../../business-components/Grid/Grid'

const EstudoFormHelp = ( { values, helpTextMorte, helpTextInvalidez } ) => {

    return (
        <GridItem12>
            <br/>
            {values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorteAte ||
            values.morteInvalidezEstudo === HARDCODE.morteInvalidezEstudoMorte
                ?
                    formataEstudoHelpText(helpTextMorte)
                :
                    formataEstudoHelpText(helpTextInvalidez)
            }
        </GridItem12>
    )
}

export default EstudoFormHelp